module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card gl-container-shadow"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group row gl-actionbar"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('dropdown', {
    attrs: {
      "text": "",
      "type": "primary"
    }
  }, [_c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.updateSearchCriterion('all', 'ALL')
      }
    }
  }, [_vm._v("ALL")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.updateSearchCriterion('filename', 'Filename')
      }
    }
  }, [_vm._v("Filename")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.updateSearchCriterion('original_filename', 'Original Fileaname')
      }
    }
  }, [_vm._v("Original Fileaname")])])])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "input1-group3",
      "name": "input1-group3",
      "placeholder": ("Search By " + (_vm.criterion[0].toUpperCase() + _vm.criterion.slice(1)))
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }, _vm.didUpdateSearchTerm]
    }
  }), _vm._v("\n                     \n                    "), _c('span', {
    staticClass: "fa fa-remove",
    attrs: {
      "id": "searchclear"
    },
    on: {
      "click": function($event) {
        _vm.clearSearch()
      }
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [(_vm.loadingDatabase) ? _c('loader', {
    attrs: {
      "label": "Loading Database"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [(_vm.removeActive) ? _c('div', [(_vm.hasOrganization && false) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.didEditSelectedLocations
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edit Selected Uploads " + _vm._s(_vm.selectedEntities.length) + " ")]) : _vm._e(), _vm._v(" "), (_vm.hasOrganization) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.didSelectRemoveLocations
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Remove Selected Uploads " + _vm._s(_vm.selectedEntities.length))]) : _vm._e(), _vm._v(" "), (_vm.hasOrganization) ? _c('button', {
    staticClass: "btn btn-primary ml-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addNewLocation
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("  New Upload")]) : _vm._e()]) : _c('div', [(_vm.hasOrganization) ? _c('button', {
    staticClass: "btn btn-outline-danger disabled",
    attrs: {
      "type": "button",
      "aria-disabled": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Remove Selected Locations")]) : _vm._e(), _vm._v(" "), (_vm.hasOrganization) ? _c('button', {
    staticClass: "btn btn-primary ml-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addNewLocation
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("  New Upload")]) : _vm._e()])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-responsive gl-table"
  }, [_c('thead', [_c('tr', [_c('th', [_c('input', {
    staticClass: "form-check-input",
    staticStyle: {
      "margin-top": "10px",
      "z-index": "999"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.selectedAllChecked
    },
    on: {
      "change": function($event) {
        _vm.toggleCheckAll()
      }
    }
  }), _vm._v(" "), _c('dropdown', {
    attrs: {
      "id": "select-all-drop"
    }
  }, [_c('div', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "width": "10px"
    },
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.selectedPageLabel)
    },
    on: {
      "click": function($event) {
        _vm.updateSelectCriterion('page')
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "#"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.selectedAllLabel)
    },
    on: {
      "click": function($event) {
        _vm.updateSelectCriterion('all')
      }
    }
  })])])], 1), _vm._v(" "), _c('th', [_vm._v("Filename")]), _vm._v(" "), _c('th', [_vm._v("Original Filename")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Section")]), _vm._v(" "), _c('th', [_vm._v("User")]), _vm._v(" "), _c('th', [_vm._v("Published")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [(!_vm.hasOrganization) ? _c('tr', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.entityList), function(entity) {
    return _c('tr', [_c('td', [_c('input', {
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": entity.checked
      },
      on: {
        "change": function($event) {
          _vm.toggleCheckLocation(entity)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entity.filename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entity.original_filename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entity.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entity.section))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entity.user))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(entity.updatedAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.viewReport(entity.filename, entity.section)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    }), _vm._v(" Download")])])])
  })], 2)]), _vm._v(" "), (_vm.hasOrganization) ? _c('nav', {
    staticClass: "pagination-container",
    attrs: {
      "aria-label": "Page navigation example"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', [_c('a', {
    staticClass: "first",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.clickedPage(1)
      }
    }
  }, [_vm._v("First")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.clickedPreviousPage
    }
  }, [_vm._v("<")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      class: {
        active: page === _vm.currentPage + 1
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.clickedPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "right",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.clickedNextPage
    }
  }, [_vm._v(">")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "last",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.clickedPage(_vm.pages.length)
      }
    }
  }, [_vm._v("Last")])])], 2)]) : _vm._e()])])])]), _vm._v(" "), _c('modal', {
    staticClass: "modal",
    attrs: {
      "title": "File Upload",
      "effect": "fade/zoom"
    },
    on: {
      "busy": true
    },
    model: {
      value: (_vm.uploadModal),
      callback: function($$v) {
        _vm.uploadModal = $$v
      },
      expression: "uploadModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("File Upload")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('LocationUpload', {
    attrs: {
      "upload-sections": _vm.defaultSections
    },
    on: {
      "exit": _vm.closeModal
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer hidden",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]), _vm._v(" "), _c('modal', {
    staticClass: "modal-danger",
    attrs: {
      "title": "Modal title",
      "effect": "fade/zoom"
    },
    on: {
      "ok": _vm.removeSelectedLocations
    },
    model: {
      value: (_vm.dangerModal),
      callback: function($$v) {
        _vm.dangerModal = $$v
      },
      expression: "dangerModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Are you sure you want to delete these Locations?")])]), _vm._v("\n    This cannot be undone.\n  ")]), _vm._v(" "), _c('alert', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "show": _vm.showTop,
      "placement": "top",
      "duration": "3000",
      "number": "0",
      "type": "success",
      "width": "380px",
      "dismissable": ""
    },
    on: {
      "update:show": function($event) {
        _vm.showTop = $event
      }
    },
    model: {
      value: (_vm.showTop),
      callback: function($$v) {
        _vm.showTop = $$v
      },
      expression: "showTop"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v("Success")]), _vm._v(" "), _c('p', [_vm._v("Your changes have seen saved!")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center pt-5 pb-5",
    attrs: {
      "colspan": "5"
    }
  }, [_c('h3', [_vm._v("Welcome to your GetLocal Dashboard")]), _vm._v(" "), _c('div', [_vm._v("You will receive a notification when your location information is available.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-651b651e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/ListUpload.vue
// module id = 555
// module chunks = 1